import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { API_BASE } from '../lib/utils';
import { toast } from 'sonner';
import { RotateCcw, X, Zap } from 'lucide-react';

const DemoResetBanner = ({ onReset, onQuickDemo }) => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [resetting, setResetting] = useState(false);
  const [wasReset, setWasReset] = useState(false);
  const [quickRunning, setQuickRunning] = useState(false);

  if (dismissed || !user || user.role !== 'apprentice') return null;

  const handleReset = async () => {
    setResetting(true);
    try {
      await axios.post(`${API_BASE}/demo/reset/${user.id}`);
      toast.success('Demo reset! All progress cleared.');
      setWasReset(true);
      if (onReset) onReset();
    } catch (error) {
      toast.error('Failed to reset demo');
    } finally {
      setResetting(false);
    }
  };

  const handleQuickDemo = async () => {
    setQuickRunning(true);
    try {
      await axios.post(`${API_BASE}/demo/quick-complete/${user.id}`);
      toast.success('All steps auto-completed! Personality, Discovery & Assessments done.');
      setWasReset(false);
      if (onQuickDemo) onQuickDemo();
    } catch (error) {
      toast.error('Quick demo failed');
    } finally {
      setQuickRunning(false);
    }
  };

  return (
    <div className="bg-[#1d1d1f] text-white px-4 py-2.5 flex items-center justify-center gap-3 text-sm" data-testid="demo-reset-banner">
      <span className="text-[#86868b]">Investor Demo</span>
      {wasReset ? (
        <button
          onClick={handleQuickDemo}
          disabled={quickRunning}
          className="bg-[#FF9500] hover:bg-[#E68600] text-white px-3 py-1 rounded-full text-xs font-medium transition-colors disabled:opacity-50 flex items-center gap-1.5"
          data-testid="quick-demo-btn"
        >
          <Zap className="w-3 h-3" />
          {quickRunning ? 'Running...' : 'Quick Complete All'}
        </button>
      ) : (
        <button
          onClick={handleReset}
          disabled={resetting}
          className="bg-white/10 hover:bg-white/20 text-white px-3 py-1 rounded-full text-xs font-medium transition-colors disabled:opacity-50 flex items-center gap-1.5"
          data-testid="reset-demo-btn"
        >
          <RotateCcw className="w-3 h-3" />
          {resetting ? 'Resetting...' : 'Reset Demo'}
        </button>
      )}
      <button
        onClick={() => setDismissed(true)}
        className="ml-1 p-0.5 rounded hover:bg-white/10 transition-colors text-[#86868b]"
        data-testid="dismiss-banner-btn"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default DemoResetBanner;
